import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import axios from "axios";
import { create_quotation_api, delete_cart_api } from "../Config/API";
import { ToastContainer, toast } from "react-toastify";
import { determineGSTType } from "../Common/CommonFunction";
import { useSelector, useDispatch } from "react-redux";
import { clearCart } from "../Redux/slices/cartSlice";

const schema = yup
  .object()
  .shape({
    gst_number: yup
      .string()
      .required("GST number is required !")
      .matches(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
        "Please enter a valid GST number!"
      )
      .length(15, "GST number must be exactly 15 characters long !"),
    email: yup.string().required("Customer email is required !"),
  })
  .required();
export const MultipleQuotationPreview = () => {
  const { items, totalQuantity } = useSelector((state) => state.cart);
  console.log("item", items);
  const dispatch=useDispatch(); 
  const user_details = JSON.parse(localStorage.getItem("user_details"));
  const [customer_details, setCustomer_details] = useState({
    data: {},
    gst_number: null,
    dataPresent: false,
    loading: false,
    invalid_data_present: false,
  });

  const [button_click, setButton_click] = useState(false);
  const [toolvalues, setToolvalues] = useState(items.map((ele)=>{
    let obj={
      product_code:ele.product_code,
      product_id:ele.uuid,
      quantity: 10,
      price: 100,
      total_value: 1000,
      discount: 10,
      discounted_value: 900,
    
    }
    return obj
  }));

  
  const [gst_types, setGst_types] = useState([]);
  const navigate = useNavigate();

  const handleChange = (index, field, value) => {
    console.log(index, field, value);
    const updatedData = [...toolvalues];
    updatedData[index][field] = Number(value);

    updatedData[index].total_value =
      updatedData[index].quantity * updatedData[index].price;
    updatedData[index].discounted_value =
      updatedData[index].total_value -
      (updatedData[index].total_value * updatedData[index].discount) / 100;

    console.log("updatedData", updatedData);
    setToolvalues(updatedData);
  };

  const {
    register,
    handleSubmit,
    formState,
    getValues,
    setError,
    control,
    clearErrors,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  }); // initialise the hook

  function get_gst_details() {
    const gst = getValues("gst_number");

    clearErrors();
    console.log("gst", gst.trim().length);
    if (!gst || gst.trim().length == 0) {
      setError("gst_number", {
        type: "manual",
        message: "GST number is required !",
      });
      return;
    }
    // console.log("gst",gst)
    setCustomer_details({
      data: {},
      dataPresent: false,
      loading: true,
      gst_number: null,
      invalid_data_present: false,
    });

    let arr;
    try {
      arr = determineGSTType(gst, user_details.gst_number);
    } catch (error) {
      setError("gst_number", {
        type: "manual",
        message: "Invalid GSTIN pattern !",
      });
      return;
    }

    console.log("arr", arr);
    setGst_types(arr);
    let gstData = {
      gstin: gst,
    };
    axios
      .post(`${process.env.REACT_APP_GST_CHECK_URL}`, gstData, {
        headers: {
          "x-api-key": process.env.REACT_APP_X_API_KEY,
        },
      })
      .then((res) => {
        console.log(res.data);

        console.log(
          "res?.data?.data?.data.tradeNam",
          res?.data?.data?.data.tradeNam
        );
        if (res?.data?.data?.data.tradeNam) {
          setCustomer_details({
            data: res.data.data.data,
            dataPresent: true,
            loading: false,
            gst_number: gst,
            invalid_data_present: false,
          });
        } else {
          setCustomer_details({
            data: {},
            dataPresent: true,
            loading: false,
            gst_number: gst,
            invalid_data_present: true,
          });
        }
      })
      .catch((err) => {
        console.log("err", err);

        if (err.status == 400) {
          // alert("Please provide a valid GST number");
          let message = err?.response?.data?.message;

          if (
            message &&
            message.length > 0 &&
            message == "Invalid GSTIN pattern"
          ) {
            setError("gst_number", {
              type: "manual",
              message: "Invalid GSTIN pattern !",
            });

            setCustomer_details({
              data: {},
              dataPresent: false,
              loading: false,
              gst_number: null,
              invalid_data_present: false,
            });
          } else {
            setError("gst_number", {
              type: "manual",
              message: message
                ? message
                : "Something went wrong with GST service !",
            });

            setCustomer_details({
              data: {},
              dataPresent: true,
              loading: false,
              gst_number: null,
              invalid_data_present: true,
            });
          }
        } else {
          setError("gst_number", {
            type: "manual",
            message: "Something went wrong with GST service !",
          });
          setCustomer_details({
            data: {},
            dataPresent: true,
            loading: false,
            gst_number: null,
            invalid_data_present: true,
          });
        }
      });
  }

  const onSubmit = (data) => {
    setButton_click(true);

    console.log("data", data);
    console.log("toolsdata,", toolvalues);
    const today = new Date(Date.now());
    const formattedDate = today.toISOString().split("T")[0];
    // console.log(formattedDate);
    let line_items_payload=[]; 
    for(let i=0; i<items.length; i++){
      let quote_image_url = new URL(items[i].quotation_product_img).pathname;

      let dimension_arr = items[i].items.map((item) => {
      let obj = {
        uom_value: item.uom_value,
        attribute_value: item.attribute_value,
        tol_positive: item.tol_positive,
        tol_negative: item.tol_negative,
        parameters_code: item.toolparameter.parameters_code,
      };
      return obj;
    });
    console.log("dimension", dimension_arr);
      let obj={
        quantity:`${toolvalues[i].quantity}`,
        product_code:toolvalues[i].product_code,
        product_id:toolvalues[i].product_id,
        unit: "NOS",
        amount: toolvalues[i].discounted_value,
        gst_rate: 18,
        gst_amount: toolvalues[0].discounted_value * 0.18,
        discount: toolvalues[0].discount,
        product_attributes:dimension_arr,
          common_attributes: items[i].common_attributes? Object.entries(items[i].common_attributes).map(([key, { name, value,iso_classification  }]) => ({
            name: key,
            value,
            ...(iso_classification && { iso_classification })
        })):[],
          product_image:quote_image_url
      }; 

      line_items_payload.push(obj)

    }

    
    
    
    const payload = {
      quotation_date: formattedDate,
      customer: data.customer_name,
      gst_number: data.gst_number,
      address: data.address,
      status: "Pending",
      email: data.email,
      quote_products:line_items_payload,
      total_amount: `${toolvalues.reduce((ac,dc)=>{
              return ac+Number(dc.discounted_value)
      },0)}`,
    };

    if(gst_types.length==2){
      payload.cgst_amount=payload.total_amount*0.09;
      payload.sgst_amount=payload.total_amount*0.09;
    }else if(gst_types[0].toLowerCase()=="ugst"){
      payload.ugst_amount=payload.total_amount*0.18; 
    }else{
      payload.igst_amount=payload.total_amount*0.18; 

    }

    console.log("payload", payload);

    create_quotation_api(payload)
      .then((res) => {
        console.log("res", res);
        setButton_click(false);
        toast.success("Quotation created successfully !", {
          autoClose: 2000,
        });
        
        delete_cart_api({user_id:user_details.user_id}).then((resp)=>{
          console.log("res",resp);
          dispatch(clearCart())
        })
        setTimeout(() => {
          navigate("/quotation");
        }, [2200]);
      })
      .catch((err) => {
        console.log("err", err);
        setButton_click(false);
        toast.error("Something went wrong !", {
          autoClose: 2000,
        });
      });
  };
  const { errors } = formState;
  return (
    <>
      <div className="px-10 py-4 h-full overflow-y-auto pb-[10%] ">
        <ToastContainer />
        <h2 className="text-start mb-3 text-2xl font-semibold	">
          Quotation Preview
        </h2>
        <hr className="w-90 h-1 mx-auto my-2 line-color border-0 rounded line-color" />

        <div className="h-full w-full">
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg 	">Customer Details</h1>
            <div className="mb-5 w-full">
              <div className="w-60 flex">
                <div className="flex-1 mr-3">
                  <input
                    type="text"
                    className="w-80 p-2 border border-gray-300 rounded bg-gray-100"
                    name="gst_number"
                    placeholder="Please enter GST number"
                    {...register("gst_number")}
                  />
                  <span className="text-danger" style={{ fontSize: "12px" }}>
                    {errors.gst_number?.message}
                  </span>
                </div>

                <div className="flex-1 start">
                  <button
                    className={
                      customer_details.loading == false
                        ? `w-40 main-color  p-2 rounded-lg text-white  cursor-pointer`
                        : `w-40 secondary-color p-2 rounded-lg text-white  cursor-pointer`
                    }
                    disabled={customer_details.loading}
                    onClick={() => {
                      get_gst_details();
                    }}
                  >
                    {customer_details.loading ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    <span>Fetching...</span>
                  </div>
                ) : (
                  "Get Details"
                )}
                  </button>
                </div>
              </div>

              {customer_details.dataPresent && (
                <div className="flex gap-4 mt-3">
                  <div className="flex-1">
                    <label className="block mb-2">Customer Name</label>
                    <input
                      type="text"
                      defaultValue={customer_details?.data?.tradeNam}
                      name="customer_name"
                      readOnly={!customer_details.invalid_data_present}
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                      {...register("customer_name")}
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block mb-2">Customer Email</label>
                    <input
                      type="text"
                      // defaultValue={customer_details?.gst_number}
                      // readOnly={!customer_details.invalid_data_present}
                      name="email"
                      placeholder="please enter customer email"
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                      {...register("email")}
                    />
                    <span className="text-danger" style={{ fontSize: "12px" }}>
                      {errors.email?.message}
                    </span>
                  </div>
                  <div className="flex-1">
                    <label className="block mb-2">GST Number</label>
                    <input
                      type="text"
                      defaultValue={customer_details?.gst_number}
                      readOnly={!customer_details.invalid_data_present}
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100"
                    />
                  </div>
                </div>
              )}
              {customer_details.dataPresent && (
                <div className=" mt-4">
                  <label className="block mb-2">Address</label>
                  <textarea
                    type="text"
                    name="address"
                    defaultValue={
                      !customer_details.invalid_data_present
                        ? customer_details?.data?.adadr?.length > 0
                          ? customer_details.data.adadr[0].addr.bno +
                            " " +
                            customer_details.data.adadr[0].addr.bnm +
                            " " +
                            customer_details.data.adadr[0].addr.st +
                            " " +
                            customer_details.data.adadr[0].addr.loc
                          : customer_details.data.pradr?.addr?.bno +
                            " " +
                            customer_details.data.pradr?.addr?.bnm +
                            " " +
                            customer_details.data.pradr?.addr?.st +
                            " " +
                            customer_details.data.adadr?.addr?.loc
                        : ""
                    }
                    readOnly={!customer_details.invalid_data_present}
                    className="resize w-1/2  p-2 border border-gray-300 rounded bg-gray-100"
                    {...register("address")}
                  />
                </div>
              )}
            </div>
          </div>
          <hr className="w-90 h-1 mx-auto my-2 line-color border-0 rounded line-color" />

          {items.map((ele) => {
            return (
              <div key={ele.uuid}>
                {/* <div className="justify-center">
                  <h1 className="text-start text-lg">Product Image</h1>
                  <div className="w-60 h-64 flex align-center">
                  <img
                    src={
                      ele.quotation_product_img ||
                      "https://via.placeholder.com/150"
                    }
                    alt={ele.product_code || "Product Image"}
                  />
                  </div>
                 
                </div>
                <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" /> */}

                <div className="mb-4 pl-2">
                  <h1 className="text-start mb-3 mt-2 text-lg">
                    Tool Dimensions
                  </h1>

                  <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
                    <thead className="bg-gray-200 font-bold">
                      <tr>
                        <th className="border border-gray-300 px-4 py-2 text-start">
                          Dimensional Parameters
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          Value
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          UOM
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          + TOL
                        </th>
                        <th className="border border-gray-300 px-4 py-2">
                          - TOL
                        </th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-700">
                      {ele.items.map((item, i) => (
                        <tr key={item.uuid}>
                          <td className="border border-gray-300 px-4 py-2 ">
                            {item.toolparameter.parameters_code}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.attribute_value}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.uom_value}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.tol_positive}
                          </td>
                          <td className="border border-gray-300 px-4 py-2 text-center">
                            {item.tol_negative}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />

                <div className="mb-4 pl-2">
                  <h1 className="text-start mb-3 mt-2 text-lg">
                    Common Attributes
                  </h1>

                  <div className="flex flex-wrap gap-4">
                    {Object.keys(ele.common_attributes).map((item,j) => {
                      return (
                        <div key={item+j} className="flex-32">
                          <label className="block mb-2">{item}</label>
                          <input
                            type="text"
                            value={`${ele.common_attributes[`${item}`].value}`}
                            // value={`${location.state.common_attributes.item.value}`}
                            disabled
                            className="w-full p-2 border border-gray-300 rounded"
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            );
          })}

          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg">
              Pricing and Terms & Condition
            </h1>
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                <th className="border border-gray-300 px-4 py-2 text-start">
                    Product Code
                  </th>
                  
                  <th className="border border-gray-300 px-4 py-2 text-start">
                    Quantity
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Value/Unit
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Total Value
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Discout %
                  </th>
                  <th className="border border-gray-300 px-4 py-2">
                    Discounted Value
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {toolvalues.length > 0 &&
                  toolvalues.map(
                    (
                      {
                        product_code,
                        quantity,
                        price,
                        discount,
                        discounted_value,
                        total_value,
                      },
                      index
                    ) => (
                      <tr key={product_code + index}>
                        <td className="border border-gray-300 px-4 py-2 ">
                          <input
                            type="text"
                            min="1"
                            className="w-40 p-2 border border-gray-300 rounded"
                            value={product_code}
                            readOnly                           
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 ">
                          <input
                            type="number"
                            min="1"
                            className="w-20 p-2 border border-gray-300 rounded"
                            defaultValue={quantity}
                            onChange={(e) =>
                              handleChange(index, "quantity", e.target.value)
                            }
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            min={"1"}
                            defaultValue={price}
                            onChange={(e) =>
                              handleChange(index, "price", e.target.value)
                            }
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            value={total_value}
                            disabled
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            min="0"
                            defaultValue={discount}
                            onChange={(e) =>
                              handleChange(index, "discount", e.target.value)
                            }
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>
                        <td className="border border-gray-300 px-4 py-2 text-center">
                          <input
                            type="number"
                            value={discounted_value}
                            disabled
                            className="w-20 p-2 border border-gray-300 rounded"
                          />
                        </td>

                      </tr>
                    )
                  )}
              </tbody>
            </table>
          </div>
          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mb-4 pl-2">
            <h1 className="text-start mb-3 mt-2 text-lg">GST Details</h1>
            <table className="min-w-full mt-2 table-auto border-collapse border border-gray-300">
              <thead className="bg-gray-200 font-bold">
                <tr>
                  <th className="border border-gray-300 px-4 py-2 text-start">
                    HSN
                  </th>
                  <th className="border border-gray-300 px-4 py-2">GST</th>
                  {/* <th className="border border-gray-300 px-4 py-2">CGST</th>
                <th className="border border-gray-300 px-4 py-2">SGST</th> */}
                  {gst_types.map((item,k) => {
                    return (
                      <th key={item+k} className="border border-gray-300 px-4 py-2">
                        {item}
                      </th> 
                    );
                  })}
                </tr>
              </thead>
              <tbody className="text-gray-700">
                {[1].map((item, index) => (
                  <tr key={index + item}>
                    <td className="border border-gray-300 px-4 py-2 ">
                      {" 82078000"}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {"18%"}
                    </td>
                    {/* <td className="border border-gray-300 px-4 py-2 text-center">
                    {"9%"}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    {"9%"}
                  </td> */}
                    {gst_types.map((item) => {
                      return (
                        <>
                          {item == "UGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"18%"}
                            </td>
                          )}
                          {item == "IGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"18%"}
                            </td>
                          )}
                          {item == "CGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"9%"}
                            </td>
                          )}
                          {item == "SGST" && (
                            <td className="border border-gray-300 px-4 py-2 text-center">
                              {"9%"}
                            </td>
                          )}
                        </>
                      );
                    })}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <hr className="w-90 h-1 mx-auto my-1 line-color border-0 rounded line-color" />
          <div className="mt-4 ">
            <button
              className={
                button_click == false
                  ? `w-40 main-color  p-2 rounded-lg text-white  cursor-pointer`
                  : `w-40 secondary-color p-2 rounded-lg text-white  cursor-pointer`
              }
              disabled={button_click}
              onClick={handleSubmit(onSubmit)}
            >
              {button_click ? (
                  <div className="flex items-center gap-2">
                    <svg
                      className="animate-spin h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                    <span>Creating...</span>
                  </div>
                ) : (
                  "Create Quotation"
                )}
              
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
